import { IContainerPatientFormLaunchProps } from '@lumahealthhq/ui-common';
import { Theme } from '@lumahealthhq/ui-core';

const defaultProps: Partial<IContainerPatientFormLaunchProps> = {
  designSystem: 'mui',
  includeFinishLater: false,
  includeQuestionNumber: true,
  toolbarPlacement: 'bottom',
  disableGutters: true,
};

const styleOverrides = {
  root: ({ theme }: { theme: Theme }) => ({
    overflow: 'auto',
    '& > form': {
      backgroundColor: theme.palette.primary[25],
      minHeight: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& .LumaFormQuestion': {
        flex: 1,
        paddingTop: theme.spacing(4),
        display: 'flex',
        justifyContent: 'center',
        '& .LumaFormQuestionPaper': {
          background: 'none',
          maxHeight: 'fit-content',
          minWidth: theme.breakpoints.values.md,
          maxWidth: theme.breakpoints.values.md,
        },
      },
      '& .LumaFormQuestionActions': {
        bgcolor: theme.palette.common.white,
        padding: theme.spacing(3),
        flex: 'none',
      },
    },
    [theme.breakpoints.down('lg')]: {
      '& > form': {
        '& .LumaFormQuestion': {
          '& .LumaFormQuestionPaper': {
            minWidth: '100%',
            minHeight: '100%',
            maxHeight: 'none',
          },
        },
      },
    },
  }),
};

export default { defaultProps, styleOverrides };
